import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

// Self-contained Cookie-Banner: nutzt localStorage und wird auf jeder Seite gerendert.
// Erscheint nur, wenn der User noch keine Entscheidung getroffen hat.
const STORAGE_KEY = "tk_cookie_consent";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    try {
      const decision = localStorage.getItem(STORAGE_KEY);
      if (!decision) {
        const timer = setTimeout(() => setIsVisible(true), 800);
        return () => clearTimeout(timer);
      }
    } catch (e) {
      // localStorage nicht verfügbar – Banner zur Sicherheit zeigen
      const timer = setTimeout(() => setIsVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleDecision = (decision) => {
    try {
      localStorage.setItem(STORAGE_KEY, decision);
      localStorage.setItem(`${STORAGE_KEY}_date`, new Date().toISOString());
    } catch (e) {
      // ignore
    }
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Cookie-Hinweis"
      className="fixed bottom-0 left-0 right-0 z-[60] p-4 md:p-6 transition-all duration-500 ease-out translate-y-0 opacity-100 animate-in slide-in-from-bottom"
    >
      <div className="container-custom">
        <div className="glass-strong rounded-2xl p-6 md:p-8 shadow-2xl max-w-4xl mx-auto relative">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
            <div className="w-12 h-12 rounded-xl bg-emerald-100 flex items-center justify-center flex-shrink-0">
              <Cookie className="w-6 h-6 text-emerald-600" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold text-slate-900 mb-1.5 font-[Outfit]">
                Cookie-Hinweis
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Diese Website verwendet ausschließlich technisch notwendige Cookies für
                ein optimales Erlebnis. Mehr Infos findest du in der{" "}
                <Link
                  to="/datenschutz"
                  className="text-emerald-600 hover:underline font-medium"
                >
                  Datenschutzerklärung
                </Link>
                .
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
              <Button
                onClick={() => handleDecision("accepted")}
                data-testid="cookie-accept-button"
                className="btn-primary px-6 py-2.5 text-sm"
              >
                Akzeptieren
              </Button>
              <Button
                onClick={() => handleDecision("declined")}
                data-testid="cookie-decline-button"
                className="btn-secondary px-6 py-2.5 text-sm"
              >
                Nur notwendige
              </Button>
            </div>
          </div>
          <button
            onClick={() => handleDecision("declined")}
            data-testid="cookie-close-button"
            className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-all"
            aria-label="Schließen"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
